export default __webpack_public_path__ + "static/media/Reconnect icon.5048a332.svg";